/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { domUtils } from '@ba-ui-toolkit/utils';

const { scrollIntoViewIfNeeded, isElementInView } = domUtils;

export default class StaticList extends Component {
	static propTypes = {
		length: PropTypes.number.isRequired,
		itemsRenderer: PropTypes.func,
		itemRenderer: PropTypes.func.isRequired,
		initialIndex: PropTypes.number,
		getScrollParent: PropTypes.func.isRequired,
	};

	componentDidMount() {
		const { initialIndex } = this.props;
		if (initialIndex > 0) {
			this.scrollTo(initialIndex);
		}
	}

	scrollAround(index) {
		this._staticScrollTo(index);
	}

	scrollTo(index) {
		this._staticScrollTo(index, true);
	}

	getVisibleRange() {
		const { children } = this._container;
		const parent = this.props.getScrollParent();
		let startRange = null;
		let endRange = null;

		for (let i = 0; i < children.length; i += 1) {
			const child = children[i];
			if (isElementInView(child, parent)) {
				if (startRange == null) {
					startRange = i;
				}

				endRange = i;
			} else if (endRange != null) {
				break;
			}
		}

		return [startRange || 0, endRange || 0];
	}

	_staticScrollTo(index, scrollTo) {
		if (this._container && index >= 0) {
			const { children } = this._container;
			if (children.length > index) {
				const child = children[index];
				if (scrollTo) {
					child.parentNode.parentNode.scrollTop = child.offsetTop;
				} else {
					scrollIntoViewIfNeeded(this.props.getScrollParent(), child);
				}
			}
		}
	}

	_itemsRenderer = (items, ref) => <div ref={ref}>{items}</div>;

	render() {
		const { length, itemsRenderer, itemRenderer } = this.props;
		const containerRenderer = itemsRenderer || this._itemsRenderer;

		const items = [];
		for (let i = 0; i < length; i += 1) {
			items.push(itemRenderer(i, i));
		}

		return containerRenderer(
			items,
			itemsContainer => (this._container = findDOMNode(itemsContainer))
		); // eslint-disable-line no-return-assign
	}
}
